import './markdown.css';
import { useParams } from "react-router-dom";
import Markdown from 'react-markdown';
import { userAPI } from "./UserAPI";
import { useEffect, useState } from "react";
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

import remarkToc from 'remark-toc';
import { ArrowLeft } from "lucide-react";

import { Button } from "@/components/ui/button";

// markdown.css folgt prefers-color-scheme; die Hilfeseiten sind aber bewusst
// immer hell (GitHub-Light-Palette). Dieser Block bleibt als Override gegen
// OS-Dark bestehen — die Werte sind die GitHub-Light-Farben der Datei selbst.
const markupPageStyles = `
  .markupPage {
    background-color: white !important;
    color: #1f2328 !important;
  }

  .markupPage .markdown-body {
    background-color: white !important;
    color: #1f2328 !important;
  }

  .markupPage .markdown-body h1,
  .markupPage .markdown-body h2,
  .markupPage .markdown-body h3,
  .markupPage .markdown-body h4,
  .markupPage .markdown-body h5,
  .markupPage .markdown-body h6 {
    color: #1f2328 !important;
  }

  .markupPage .markdown-body p {
    color: #1f2328 !important;
  }

  .markupPage .markdown-body a {
    color: #0969da !important;
  }

  .markupPage .markdown-body code {
    background-color: #f6f8fa !important;
    color: #1f2328 !important;
  }

  .markupPage .markdown-body pre {
    background-color: #f6f8fa !important;
    color: #1f2328 !important;
  }

  .markupPage .markdown-body blockquote {
    color: #636c76 !important;
    border-left-color: #d0d7de !important;
  }

  .markupPage .markdown-body table {
    border-color: #d0d7de !important;
  }

  .markupPage .markdown-body table th,
  .markupPage .markdown-body table td {
    border-color: #d0d7de !important;
  }

  .markupPage .markdown-body table tr {
    background-color: white !important;
  }

  .markupPage .markdown-body table tr:nth-child(2n) {
    background-color: #f6f8fa !important;
  }
`;

export default function MarkupPage() {
    const [markup, setMarkup] = useState('')
    const [title, setTitle] = useState('')
    const params = useParams();

    // Inject styles to override dark mode
    useEffect(() => {
        const styleElement = document.createElement('style');
        styleElement.textContent = markupPageStyles;
        document.head.appendChild(styleElement);

        return () => {
            document.head.removeChild(styleElement);
        };
    }, []);

    useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      }, [markup]);

    useEffect(() => {
        const call = async () => {
            if (params && params['*']) {
                const path = params['*'];
                const resourcePath = path.lastIndexOf('/') >= 0 ? path.substring(path.lastIndexOf('/')) : '';
                const resource = path.substring(path.lastIndexOf('/') ? path.lastIndexOf('/') + 1 : 0, path.indexOf('.'));
                let newMarkup = await userAPI.getMarkup(path);

                console.log(newMarkup);
                newMarkup = newMarkup.replace(/!\[Image\]\(/g, `![Image](${userAPI.getResourceURL(resourcePath)}/markup/`);
                console.log(newMarkup);

                setMarkup(newMarkup);
                setTitle(resource.replace(/_/g, ' '));
            }
        };

        call();
    }, [params]);

    const back = () => {
        window.history.back()
    }

    // Der Titelbalken steht außerhalb des markdown-body-Scopes, damit die
    // GitHub-Heading-Styles (Margin, Trennlinie) ihn nicht erfassen.
    return <div className="markupPage min-h-dvh">
        <div className="flex items-center border-b border-border p-2">
            <Button type="button" variant="ghost" size="icon" aria-label="Zurück" onClick={back}>
                <ArrowLeft aria-hidden="true" className="h-5 w-5" />
            </Button>
            <div className="flex flex-1 justify-center">
                <h1 className="text-2xl font-semibold">{title}</h1>
            </div>
        </div>
        <div className="mt-8 flex justify-center pb-12">
            <div className="markdown-body w-full max-w-[900px] px-4">
                <Markdown rehypePlugins={[rehypeRaw] as any} remarkPlugins={[remarkGfm, [remarkToc, { heading: 'toc|inhaltsverzeichnis|inhalt|table[ -]of[ -]contents?' }]]}>{markup}</Markdown>
            </div >
        </div>
    </div>;
}
